// Central testimonials data shared by desktop and mobile landing pages.
// Each testimonial includes schoolId for map dot matching
export const testimonials = [
  {
    schoolId: 'bc',
    name: 'Mia Rodriguez',
    school: 'Boston College',
    quote: 'Scout basically became my study partner. Uploading syllabi once and having everything mapped out saved me before midterms.',
    logo: '/college_logos/boston_college_logo.png',
    verified: true
  },
  {
    schoolId: 'ucsd',
    name: 'Ethan Carter',
    school: 'University of San Diego',
    quote: 'It\'s wild how much time I was wasting organizing due dates. Now it\'s all automatic — I actually sleep during finals week.',
    logo: '/college_logos/university_of_san_diego_logo.png',
    verified: true
  },
  {
    schoolId: 'stmarys',
    name: 'Priya Patel',
    school: 'St. Mary\'s College',
    quote: 'At first I thought it was just another AI gimmick. Then Scout caught two assignment changes my professor posted at 1 a.m. It\'s legit.',
    logo: '/college_logos/st_marys_college_logo.png',
    verified: true
  },
  {
    schoolId: 'uvm',
    name: 'Aiden Thompson',
    school: 'University of Vermont',
    quote: 'My entire team used DocuHounds for our capstone project. It kept our deadlines synced and group stress low.',
    logo: '/college_logos/university_of_vermont_logo.png',
    verified: true
  },
  {
    schoolId: 'rutgers',
    name: 'Sara Lin',
    school: 'Rutgers University',
    quote: 'As a grad student juggling work and classes, Scout is the reason I\'m still sane.',
    logo: '/college_logos/rutgers_university.png',
    verified: true
  },
  {
    schoolId: 'unc',
    name: 'Jordan Kim',
    school: 'University of North Carolina',
    quote: 'When my Canvas calendar glitched, Scout still had every date correct. That was the moment I realized this thing\'s smarter than most LMS apps.',
    logo: '/college_logos/university_of_north_carolina.png',
    verified: true
  },
  {
    schoolId: 'xavier',
    name: 'Hannah O\'Reilly',
    school: 'Xavier University',
    quote: 'DocuHounds turns chaos into clarity. My friends keep asking how my dashboard looks so clean — I just tell them, "Scout did it."',
    logo: '/college_logos/xavier_university_logo.png',
    verified: true
  },
  {
    schoolId: 'vanderbilt',
    name: 'Tyler Nguyen',
    school: 'Vanderbilt University',
    quote: 'I used to be the one spamming our group chat about due dates. Now Scout does it for me. My group loves me again.',
    logo: '/college_logos/vanderbilt_university_logo.png',
    verified: true
  },
  {
    schoolId: 'uportland',
    name: 'Emily Stone',
    school: 'University of Portland',
    quote: 'I didn\'t expect it to actually understand my notes. The AI summaries are crazy good — like a study buddy who never forgets anything.',
    logo: '/college_logos/university_of_portland_logo.png',
    verified: true
  },
  {
    schoolId: 'calpoly',
    name: 'Liam Donovan',
    school: 'Cal Poly',
    quote: 'Scout helped me balance research deadlines and hockey practice. It\'s basically the academic coach every student needs.',
    logo: '/college_logos/cal_poly_logo.png',
    verified: true
  }
];
